/* eslint-disable no-magic-numbers */
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faRupeeSign } from '@fortawesome/free-solid-svg-icons';
import { Options } from '@angular-slider/ngx-slider';

@Component({
  selector: 'app-price-filter',
  templateUrl: './price-filter.component.html',
  styleUrls: ['./price-filter.component.scss',],
})
export class PriceFilterComponent {

  faRupeeSign = faRupeeSign;
  multipleOf = 1000;
  minPrice: number = 10;
  maxPrice: number = 300;
  selectedPrice: number = this.maxPrice * this.multipleOf;

  defaultOption: Options = {
    floor: 10,
    ceil: 300,
    step: 10,
    showTicks: false,
    showTicksValues: false,
    showSelectionBar: true,
    getSelectionBarColor: () => '#ed224d',
  };

  constructor(
    private _router: Router,
    private _activateRoute: ActivatedRoute
  ) {
    this._activateRoute.queryParams.subscribe({
      next: ({ maxPrice, }) => {
        if (maxPrice) this.selectedPrice = maxPrice;
        else this.selectedPrice = this.maxPrice * this.multipleOf;
      },
    });
  }

  priceFilterChanged(event: any) {
    this.selectedPrice = parseInt(event?.value) * this.multipleOf;
    this._router.navigate([], {
      queryParams: {
        maxPrice: this.selectedPrice,
      },
      queryParamsHandling: 'merge',
    });
  }

}
